import moment from 'moment';
import { useThemeContext } from '../../../hooks';
export const useCalendarMonthHeight = ({ date, weekHeight, weekMargin }) => {
    const { size } = useThemeContext();
    let curr = moment(date).startOf('month').startOf('week');
    let weeks = 0;
    do {
        weeks++;
        curr = moment(curr).add(7, 'days');
    } while (curr.isSame(date, 'month'));
    const output = weeks * (weekHeight !== null && weekHeight !== void 0 ? weekHeight : size.M + size.B + size.C) +
        (weekMargin !== null && weekMargin !== void 0 ? weekMargin : 2 * size.C);
    return output;
};
//# sourceMappingURL=useCalendarHeight.js.map